import React from 'react'

import Offer from './Offer'
import ViewToggle from '../../subcomponents/ViewToggle'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const Stage = props => (
    <div className="mam3-type new-revolving-stage">

        <Offer className="banner earn" {...props} campaign={props.campaign} isArrow={false}/>

        <div className="indicators">
            <div className="indicator"></div>
            <div className="indicator active"></div>
            <div className="indicator"></div>
            <div className="indicator"></div>
            <div className="indicator"></div>
            <div className="indicator"></div>
            <div className="indicator"></div>
        </div>
    </div>
)

const NewRevolvingStage = props => {
    return (
        <ViewToggle isMobile={props.isMobile('web')}>
            <Stage
                {...props}
                disableSuperscripts={Boolean(props.isCcMedien)}
                campaign={props.campaign}
                image={
                    props.isMobile('web')
                        ? props.campaign.image_1_1
                        : props.campaign.image_5_2
                    }
                />
            <FootnotesFromContext
                showWarningText={props.footnotesWarningText}
                bigIndices={props.bigIndices}
            />
        </ViewToggle>
    )

}

export default NewRevolvingStage



// WEBPACK FOOTER //
// ./src/components/ads/mam3/NewRevolvingStage.js